import withMarketPromoPage from '../../../hocs/withMarketPromoPage';

export default withMarketPromoPage({
  pageName: 'SupportIsrael',
  marketTextKey: 'screen.supportIsraelEvents.title',
  titleKey: 'supportIsraelEvents',
  getImageSrc: () => '/static/img/supportIsrael.png',
  // backgroundPosition: 'center',
  filters: {
    context: 'support_israel',
  },
});
